import { FormikHelpers } from "formik";
import { useContext } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { isTypeOfAtmSearchForm } from "src/components/Common/UI/SydFilter/SydFilterTypeChecker";
import AtmSearchForm from "./AtmSearchForm";

const emptyAtmSearchForm: IAtmSearchForm = {
  description: "",
  //sapCode: "",
  unID: "",
  deleted: "",
  atmTerm: "",
  lineType: "",
  comments: ""
}

const SearchAtm = () => {
  const sydFilterCtx = useContext(SydFilterContext);

  const activeFilters = sydFilterCtx.activeFilters;
  const clearForm = sydFilterCtx.clearAllFilters;
  const saveFilters  = sydFilterCtx.saveFilters;
  const handleClose = sydFilterCtx.toggleFilterVisibility;

  const initialValues = isTypeOfAtmSearchForm(activeFilters) ? activeFilters as IAtmSearchForm : emptyAtmSearchForm;

  const handleSubmit = async (values: IAtmSearchForm, { setSubmitting }: FormikHelpers<IAtmSearchForm>): Promise<void> => {
    saveFilters(values);
    setSubmitting(false);
    handleClose();
  }

  return (
    <AtmSearchForm initialValues={initialValues} onSubmit={handleSubmit} onClearForm={clearForm} />
  )
}

export default SearchAtm;